import { useEffect } from "react";

type ImagePreviewProps = {
    showPopup: boolean;
    setShowPopup: (value: boolean) => void;
    imagePath: string;
}

export const ImagePreview = ({ showPopup, setShowPopup, imagePath }: ImagePreviewProps) => {

    useEffect(() => {
        if (showPopup) {
            document.body.classList.add("overflow-hidden");
        } else {
            document.body.classList.remove("overflow-hidden");
        }

        return () => {
            document.body.classList.remove("overflow-hidden");
        };
    }, [showPopup]);

    if (!showPopup) return null;

    return (
        <>
            <div className="fixed inset-0 z-[9999999] flex items-center justify-center bg-black/50 p-10">
                <div className="bg-white w-full max-w-5xl rounded-md shadow-lg max-h-[90vh] flex flex-col overflow-auto">
                    <div className="px-6 py-4 border-b w-full flex justify-between items-center">
                        <h2 className="text-lg font-medium">Image preview</h2>
                        <button
                            onClick={() => {
                                setShowPopup(false)
                            }}
                            className="text-gray-500"
                        >
                            <span className="material-symbols-outlined text-2xl">
                                close
                            </span>
                        </button>
                    </div>

                    <div className="w-full p-2">
                        {
                            !imagePath && (
                                <div className="flex items-center justify-center w-full p-2">
                                    <div className="mb-4 h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-primary" />
                                </div>
                            )
                        }
                        {
                            imagePath && (
                                <img alt="imagePreview" src={imagePath} className="w-full h-full" />
                            )
                        }

                    </div>
                </div>
            </div>
        </>
    )
}